export const TARGET_KEYS = {
  SITUAZIONE_GIORNALIE: 'situazione_giornalie',
  SITUAZIONE_SETTIMANALE: 'situazione_settimanale',
  OTTIMIZZAZIONE_STOCK: 'ottimizzazione_stock',
} as const;

export type TargetKey = (typeof TARGET_KEYS)[keyof typeof TARGET_KEYS];

export const TARGET_TITLES: Record<TargetKey, string> = {
  [TARGET_KEYS.SITUAZIONE_GIORNALIE]: 'situazione_giornaliera',
  [TARGET_KEYS.SITUAZIONE_SETTIMANALE]: 'situazione_settimanale',
  [TARGET_KEYS.OTTIMIZZAZIONE_STOCK]: 'ottimizzazione_stock',
};
